import { render, staticRenderFns } from "./composeSmsPopup.vue?vue&type=template&id=2b432be8&"
import script from "./composeSmsPopup.vue?vue&type=script&lang=js&"
export * from "./composeSmsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports